import { SlugifyPipe } from 'src/app/pipes/slugify.pipe';
import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss'],
})
export class OfferCardComponent implements OnInit {
  @Input() offerItem: any;
  @Input() storeInfo: any;
  @Input() locationId: any;
  constructor(
    private navControl: NavController,
    private slugifyPipe: SlugifyPipe,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}

  viewOfferProducts() {
    this.analyticsService.trackUnified('offer_card_clicked', {
      flow: 'dutyfree',
      outcome: 'success',
      legacy_event_name: 'offer_card_clicked',
      component: 'offer-card-component',
    });
    this.navControl.navigateForward([
      'dutyfree/products',
      this.slugifyPipe.transform(this.storeInfo.storeName),
      this.storeInfo.id,
      {
        loc: this.locationId,
        promotionId: this.offerItem.id,
      },
    ]);
  }
}
